import Collapsible from './Collapsible';
export { CollapsibleContainer, CollapsiblePanelChildren, CollapsiblePanelDiv, CollapsibleTitle } from './CollapsibleItem';


export default Collapsible;